/** Softgarden Default-Password-Policy (Frontend API v3). */
export const SG_PASSWORD_MIN_LENGTH = 12;

export const validateSoftgardenPassword = (password) => {
	if (!password || typeof password !== 'string') {
		return { ok: false, code: 'empty' };
	}

	if (password.length < SG_PASSWORD_MIN_LENGTH) {
		return { ok: false, code: 'length' };
	}

	if (!/[A-Z]/.test(password) || !/[a-z]/.test(password) || !/\d/.test(password) || !/[^A-Za-z0-9]/.test(password)) {
		return { ok: false, code: 'complexity' };
	}

	return { ok: true };
};

/** Token aus Softgarden-Reset-Mail (Query-Param, typisch authToken). */
export const readResetAuthToken = (search = window.location.search) => {
	const params = new URLSearchParams(search);
	return (
		params.get('authToken')
		|| params.get('auth_token')
		|| params.get('token')
		|| ''
	).trim();
};

export const clearResetAuthTokenFromUrl = () => {
	const url = new URL(window.location.href);
	['authToken', 'auth_token', 'token'].forEach((key) => url.searchParams.delete(key));

	const next = `${url.pathname}${url.search}${url.hash}`;
	window.history.replaceState({}, document.title, next);
};
